import { useParams } from "react-router-dom";
import React, { memo } from "react";
import { Button, CircularProgress } from "@mui/material";
import useTagTigerGetLogisticById from "./hooks/useTagTigerGetLogisticById";
import useLongPulling from "./hooks/useLongPulling";
import useStopLongPulling from "./hooks/useStopLongPulling";

function PullingButton() {
  const { logisticTaskId } = useParams();

  const reFetchLogisticById = useTagTigerGetLogisticById({ logisticTaskId });

  useLongPulling({ onStop: reFetchLogisticById, logisticTaskId });

  const { handleClick, isStopping } = useStopLongPulling({
    onSuccess: reFetchLogisticById,
    logisticTaskId
  });

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      disabled={isStopping}
      startIcon={<CircularProgress size="20px" color="inherit" />}
    >
      {isStopping ? "Останавливается" : "Остановить построение маршрута"}
    </Button>
  );
}

export default memo(PullingButton);
